import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Button } from '../../../components/Button';

import * as api from '../../../api';
import * as logger from '../../../logger';

import defaultStyle from '../../../styles/formSetStyles.module.css';
import introPageStyles from '../../FormStart/IntroPage/index.module.css';
import styles from '../index.module.css';

interface Props
  extends RouteComponentProps<{
    authenticationCode: string;
  }> {
  selectedFormSetId: string;
  onSubmit: () => void;
  feedback?: string;
}

const PaymentFeedback: React.FC<Props> = ({
  match,
  selectedFormSetId,
  onSubmit,
  feedback,
}) => {
  const [textAreaValue, setTextAreaValue] = useState(feedback || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleClickSubmit = async () => {
    const trimmedTextAreaValue = textAreaValue.trim();
    if (trimmedTextAreaValue === feedback) {
      onSubmit();
      return;
    }
    setIsSubmitting(true);
    try {
      await api.client.Payment.updatePatientSkipFeedback({
        authenticationCode: match.params.authenticationCode,
        previsitFormSetId: selectedFormSetId,
        feedback: trimmedTextAreaValue,
      });
    } catch (e) {
      logger.error(e, `[PaymentFeedback][handleClickSubmit]`);
    }
    setIsSubmitting(false);
    onSubmit();
  };

  return (
    <div>
      <div
        className={classNames(introPageStyles.Label, styles.HeaderTextSpacing)}
      >
        {t('Do you have any feedback for improving the payment experience?')}
      </div>
      <div>
        <textarea
          id="feedback-comments"
          className={[defaultStyle.Textarea, styles.DetailsInput].join(' ')}
          value={textAreaValue}
          onChange={(event: React.FormEvent<HTMLTextAreaElement>) =>
            setTextAreaValue(event.currentTarget.value)
          }
          placeholder={t('Enter your answer here...')}
        />
      </div>
      <div className={defaultStyle.ButtonSubmitWrapper}>
        <Button
          disabled={isSubmitting}
          type="button"
          children={t('Continue')}
          onClick={handleClickSubmit}
        />
      </div>
    </div>
  );
};

export default withRouter(PaymentFeedback);
